import React from 'react';
import { Container, Card, CardBody, Button } from 'reactstrap';
import { DataTable, Column } from 'vivace-fluent-motion';
import IntlMessage from '../../../../helpers/intlMessage';
import * as commonActions from '../../../../app/common/common.action';
import { useDispatch } from 'react-redux';
import { UncontrolledTooltip } from 'reactstrap/lib/Uncontrolled';
import { indexOf } from 'lodash';

function Grid({
  lista,
  pagina,
  totalItens,
  totalItensPage,
  setPagina,
}) {

  const dispatch = useDispatch();

  const btnFaturar = (item) => {
    return (
      <Button
        color='success'
        disabled={item.statusExame || item.faturado}
        onClick={() => {
          dispatch(commonActions.atualizarLaudoSelecionado({
            laudo: item.laudo,
            prontuario: item.prontuario,
            exame: item.exame,
          }));
          dispatch(commonActions.mudarStatusModalFaturamento(true))
        }
        }
      >
        <span><IntlMessage id="dashboards.examDetails.invoice" /></span>
      </Button>
    )
  }

  const statusFaturar = (e) => {
    if (e.faturado) {
      return (
        <span className="badge badge-secondary"
          style={{
            backgroundColor: "#44A820",
            color: "white",
            padding: "6px 10px",
            fontSize: "0.7rem"
          }}
        ><IntlMessage id="dashboards.examDetail.billed" /></span>
      );
    } else {
      return (
        <span className="badge badge-secondary"
          style={{
            backgroundColor: "#F7EE8E",
            color: "black",
            padding: "6px 10px",
            fontSize: "0.7rem"
          }}
        ><IntlMessage id="dashboards.examDetail.pendingBilling" /></span>
      );
    }
  }

  const statusExame = (e) => {
    e.id = parseInt(Math.random() * 20000);
    if (e.status.includes('sucesso')) {
      return (
        <span className="badge badge-secondary"
          id={`laudo_${e.id}`}
          style={{
            backgroundColor: "#44A820",
            color: "white",
            padding: "6px 10px",
            fontSize: "0.7rem"
          }}
        >{e.status}
          <UncontrolledTooltip
            placement="top"
            target={`laudo_${e.id}`}
          >
            {e.status}
          </UncontrolledTooltip>
        </span>
      );
    } else if (e.status.includes('problema')) {
      return (
        <span className="badge badge-secondary"
          id={`laudo_${e.id}`}
          style={{
            backgroundColor: "#F7EE8E",
            color: "black",
            padding: "6px 10px",
            fontSize: "0.7rem"
          }}
        ><IntlMessage id="dashboards.examDetail.thereWasProblem" />
          <UncontrolledTooltip
            placement="top"
            target={`laudo_${e.id}`}
          >
            {e.status}
          </UncontrolledTooltip></span>
      );
    } else {
      return (
        <span className="badge badge-secondary"
          id={`laudo_${e.id}`}
          style={{
            backgroundColor: "#F7EE8E",
            color: "black",
            padding: "6px 10px",
            fontSize: "0.7rem"
          }}
        >{e.status}
          <UncontrolledTooltip
            placement="top"
            target={`laudo_${e.id}`}
          >
            {e.status}
          </UncontrolledTooltip></span>
      );
    }
  }

  function Footer({ totalItens }) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItens: 'center'
        }}
      >
        <span
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItens: 'center'
          }}
        >
          <i
            className='mv-basico-stacktrace'
            style={{ fontSize: '20px', height: '18px' }}
          />{' '}
          <span style={{ marginTop: '2px' }}>
            <IntlMessage id="dashboards.reports.totalReports" /> {totalItens}
          </span>
        </span>
      </div>
    );
  }

  return (
    <Card>
      <CardBody>
        <Container fluid>
          <DataTable
            onContextMenu={() => { }}
            value={lista}
            responsive={true}
            selectionMode='single'
            scrollHeight='calc(100vh - 286px)'
            columnResizeMode='expand'
            scrollable={true}
            scrollWidth='100%'
            resizableColumns={lista.length >= 1}
            reorderableColumns={lista.length >= 1}
            first={(pagina - 1) * totalItensPage}
            rows={totalItensPage}
            lazy={true}
            paginator={lista.length > 0}
            emptyMessage={<IntlMessage id="dashboards.reports.noResultsFound" />}
            alwaysShowPaginator={false}
            autoLayout={true}
            totalRecords={totalItens}
            onPage={event => setPagina(event.page + 1)}
            footer={<Footer totalItens={totalItens} />}
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          >
            <Column
              sortable={false}
              field='select'
              style={{ width: '25px' }}
            />
            <Column
              field='nrexame'
              style={{ width: '80px' }}
              header={<IntlMessage id="general.materialArchiving.examNumber" />}
            />
            <Column
              field='exameNome'
              style={{ width: '100px' }}
              header={<IntlMessage id="dashboards.cytology.nameOfExam" />}
            />
            <Column
              field='status'
              style={{ width: '110px' }}
              header={<IntlMessage id="dashboards.examDetails.examStatus" />}
              body={(e) => statusExame(e)}
            />
            <Column
              field='pacienteNome'
              style={{ width: '100px' }}
              header={<IntlMessage id="dashboards.cytology.nameOfPatient" />}
            />
            <Column
              field='medicoCertificador'
              style={{ width: '100px' }}
              header={<IntlMessage id="dashboards.general.certifyingDoctor" />}
            />
            <Column
              field='dataPedido'
              style={{ width: '100px' }}
              header={<IntlMessage id="dashboards.reports.dateRequest" />}
            />
          </DataTable>
        </Container>
      </CardBody>
    </Card>
  );
}

export default Grid;


// WEBPACK FOOTER //
// ./src/pages/relatorio/Certificacao/Grid/index.js